const SCROLLABLE = new Set(['auto', 'scroll', 'overlay']);
const LINE_HEIGHT = 16;
const VERTICAL_SLACK = 8;

const targets = new WeakMap<Element, number>();

function scrollsY(el: Element, style: CSSStyleDeclaration) {
  return SCROLLABLE.has(style.overflowY) && el.scrollHeight - el.clientHeight > VERTICAL_SLACK;
}

function scrollsX(el: Element, style: CSSStyleDeclaration) {
  return SCROLLABLE.has(style.overflowX) && el.scrollWidth - el.clientWidth > 1;
}

function canMoveY(el: Element, delta: number) {
  return delta < 0 ? el.scrollTop > 0 : el.scrollTop + el.clientHeight < el.scrollHeight - 1;
}

function canMoveX(el: Element, delta: number) {
  return delta < 0 ? el.scrollLeft > 0 : el.scrollLeft + el.clientWidth < el.scrollWidth - 1;
}

function pixels(event: WheelEvent, el: Element) {
  if (event.deltaMode === WheelEvent.DOM_DELTA_LINE) return event.deltaY * LINE_HEIGHT;
  if (event.deltaMode === WheelEvent.DOM_DELTA_PAGE) return event.deltaY * el.clientWidth;
  return event.deltaY;
}

function isNotchedWheel(event: WheelEvent) {
  return event.deltaMode !== WheelEvent.DOM_DELTA_PIXEL || (Number.isInteger(event.deltaY) && Math.abs(event.deltaY) >= 50);
}

function scrollHorizontally(el: Element, event: WheelEvent) {
  const delta = pixels(event, el);
  const max = el.scrollWidth - el.clientWidth;
  if (!isNotchedWheel(event)) {
    targets.delete(el);
    el.scrollLeft = Math.max(0, Math.min(max, el.scrollLeft + delta));
    return;
  }
  const from = targets.get(el) ?? el.scrollLeft;
  const to = Math.max(0, Math.min(max, from + delta));
  targets.set(el, to);
  el.scrollTo({ left: to, behavior: 'smooth' });
  el.addEventListener('scrollend', () => targets.delete(el), { once: true });
}

function onWheel(event: WheelEvent) {
  if (event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey) return;
  if (!event.deltaY || Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;
  let el = event.target instanceof Element ? event.target : null;
  while (el && el !== document.documentElement && el !== document.body) {
    const style = getComputedStyle(el);
    if (scrollsY(el, style) && canMoveY(el, event.deltaY)) return;
    if (scrollsX(el, style) && !scrollsY(el, style) && canMoveX(el, event.deltaY)) {
      event.preventDefault();
      scrollHorizontally(el, event);
      return;
    }
    el = el.parentElement;
  }
}

export function installWheelScroll() {
  window.addEventListener('wheel', onWheel, { passive: false });
}
